<footer class="main-footer">
  <div class="float-right d-none d-sm-block">
    
  </div>
  <strong
    >Copyright &copy; 
    <a href="http://thienan.vn">Thiên An</a></strong
  >

</footer>
